import React, { useRef, useEffect, useCallback } from 'react';
import { useSpring, animated } from 'react-spring';
import styled from 'styled-components';
import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './signup.css';


const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalWrapper = styled.div`
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: #fff;
  color: #000;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  position: relative;
  z-index: 10;
  border-radius: 10px;
`;


const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1.8;
  color: #141414;
  p {
    margin-bottom: 1rem;
  }
  button {
    padding: 10px 24px;
    background: #141414;
    color: #fff;
    border: none;
  }
`;


export const SignUpModalFaild = ({ showModal, setShowModal }) => {
  const modalRef = useRef();

  const animation = useSpring({
    config: {
      duration: 250
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`
  });

  const closeModal = e => {
    if (modalRef.current === e.target) {
      setShowModal(false);
    }
  };

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModal) {
        setShowModal(false);
        console.log('I pressed');
      }
    },
    [setShowModal, showModal]
  );

  useEffect(
    () => {
      document.addEventListener('keydown', keyPress);
      return () => document.removeEventListener('keydown', keyPress);
    },
    [keyPress]
  );

  return (
    <>
      {showModal ? (
          
        <Background onClick={closeModal} ref={modalRef} style={{zIndex:1000}}>
          <animated.div style={animation}>
            <ModalWrapper showModal={showModal} className="con">
            <FontAwesomeIcon icon={faClose}         size="2x"         onClick={() => setShowModal(prev => !prev)} style={{position:'absolute',top:10,right:10}}/>
            <img src="./assets/svgs/error-svgrepo-com.svg" alt="Logo"className='img-sucsess'/>
     
  <ModalContent>
       <h2 className='header-sucsess' >Something wong !</h2>
       <p>Email or Username already used.</p>
     </ModalContent>
  
           
            </ModalWrapper>
          </animated.div>
        </Background>
      ) : null}
    </>
  );
};